/* tslint:disable:typedef-whitespace no-trailing-whitespace no-inferrable-types import-spacing */

import { ElementRef }         from '@angular/core';

import { Dialog }             from './dialog';
import { Logger }             from '@/util/logger';

import { IValidatorCallBack } from './i.validator.call.back';
import { IOkCallBack        } from './i.ok.call.back';

import * as $                 from 'jquery';
import 'jquery-ui-dist/jquery-ui';

/**
 *
 * @class NewSimulationDialog
 *
 * @brief dialog for grabbing a name for another simulation group before actually
 * adding it.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      April 2020
 *
 */
export class NewSimulationDialog extends Dialog {

  /** thte name we're trying get from the user */
  private name;

  /** timer to wait for user to stop typing */
  private typingTimer = null;

  /** standard constructor, allow for partial alert to be given */
  constructor(
    host: ElementRef
  ) {

    super(host);

    this.title = 'New Simulation Group';
    this.icon  = '<i class="fas fa-plus"></i>';

    Logger.debug('[NewSimulationDialog] setting up...');
  }

  /** dialog has been opened */
  public open(validator?: IValidatorCallBack, success?: IOkCallBack, options?: any) {

    this.validator = validator ? validator : null;
    this.success   = success   ? success   : null;

    if (this.typingTimer) {

      clearTimeout(this.typingTimer);

      this.typingTimer = null;
    }

    Logger.debug('[NewSimulationDialog] opening...');

    this.name = '';

    const body = $(this.host).find('.modal-body');

    const html = `
<div style="margin-top: 12px;">
<label class="gui-label">Name:</label>
<input class="gui-input simulation-name-input" type="text" placeholder="Simulation Name">
</div>
<div class="gui-error-line"></div>
    `;

    $(body).html(html);

    /* add behaviors */

    setTimeout(() => {

      $(this.host).find('.simulation-name-input').focus();

      $(this.host).find('.simulation-name-input').on('input', (e) => {

        /* typing wait: @link https://stackoverflow.com/questions/10124114/wait-for-function-till-user-stops-typing */

        if (this.typingTimer) {

          clearTimeout(this.typingTimer);
        }

        this.typingTimer = setTimeout(() => {

          this.name = ($(e.currentTarget).val() as string).trim();

          this.validate();

        }, 400);

      });

      $(this.host).find('.simulation-name-input').on('keypress', (e) => {

        if (this.typingTimer) {

          clearTimeout(this.typingTimer);
        }

        this.typingTimer = setTimeout(() => {

          this.name = ($(e.currentTarget).val() as string).trim();

          if (e.key.toLowerCase() === 'enter') {

            this.validate(true);

            /* stop event propagation */

            return false;
          }

        }, 400);

      });

    }, 50);

    /* disable the Ok button...until we have valid input */

    this.validate();
  }

  disable() {

    const ok = $(this.host).find('.modal-ok-button');

    $(ok).attr('disabled', 'true');
    $(ok).addClass('disabled');
  }

  enable() {

    const ok = $(this.host).find('.modal-ok-button');

    $(ok).removeAttr('disabled');
    $(ok).removeClass('disabled');

  }

  /** show a validation error */
  error(msg: string) {

    const display = $(this.host).find('.gui-error-line');

    $(display).html(msg);
  }

  /* don't enable the Ok button until we have what we need. */
  validate(transition: boolean = false) {

    this.error('');

    /* assume its bad */

    this.disable();

    if (!this.validator) {

      /* at least make sure the name is't empty */

      if (this.name === '') {

        const display = $(this.host).find('.gui-error-line');

        $(display).html('Simulation name can not be empty.');

        return ;
      }

      this.enable();

      /* if we make it through validation checks, and we're allowed to transition, then do it. */

      if (transition) {

        /* click the ok button for them, and trigger via ModelComponent */

        const ok = $(this.host).find('.modal-ok-button');

        $(ok).click();
      }

    } else {

      /* wrap validation in a promise, so its ok if its asynchronous */

      const p = new Promise((resolve, reject) => {

        this.validator(this.name, resolve, reject);

      }).then((name) => {

        this.enable();

        this.name = name;

        if (transition) {

          /* click the ok button for them, and trigger via ModelComponent */

          const ok = $(this.host).find('.modal-ok-button');

          $(ok).click();
        }

      }).catch((error) => {

        /* show the validation error */

        this.error(error);

      });

    }

  }

  /** dialog is closing */
  public close() {

    Logger.debug('[NewSimulationDialog] closing...');
  }

  /** dialog was accepted */
  public ok() {

    Logger.debug('[NewSimulationDialog] accepted: ', this.name);

    if (this.success) {

      /* inform the client */

      this.success(this.name);
    }

  }
}


